import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  padding: 0.5rem 1rem;
`;

export const Name = styled.p`
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
`;

export const Description = styled.p`
  font-size: 1rem;
  margin-bottom: 0.5rem;
`;

export const DescriptionLabel = styled.label`
  display: block;
  font-size: 0.75rem;
`;

export const ProgressLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const ProgressBar = styled.div<{ value?: number }>`
  width: 100%;
  height: 6px;
  background-color: ${({ theme }) => theme.colors.orochimaru};
  position: relative;

  ${({ value }) =>
    value &&
    css`
      &::after {
        content: "";
        background-color: ${({ theme }) => theme.colors.blueDianne};
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: ${value}%;
      }
    `}
`;
